import { FC, useContext } from 'react';
import { useParams } from 'react-router';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import Page from '../page/PreviewCommentEditPage';

type Props = { className?: string };
type Params = {
  id: string;
  page?: string;
};

const PreviewCommentEditPage: FC<Props> = ({ className }) => {
  const { id, page } = useParams<Params>();
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const history = useContext(HistoryContext);

  return (
    <Page
      updateComment={dependency.previewCommentUsecase.updateComment}
      pagePreviewsLoading={state.pagePreviews.fetching > 0}
      currentPagePreview={state.currentPagePreview.data}
      isUpdatingComment={state.updateComment.fetching > 0}
      isCreatingReturnComment={state.createReturnComment.fetching > 0}
      isCreatingNewPostion={state.createNewPosition.fetching > 0}
      isAppendingPreviewPage={state.appendPreviewPage.fetching > 0}
      isGetCurrentPreviewPage={state.currentPagePreview.fetching > 0}
      createNewPosition={dependency.previewCommentUsecase.createNewPosition}
      createReturnComment={dependency.previewCommentUsecase.createReturnComment}
      notifyUnimportant={dependency.messageDispatcher.notifyUnimportant}
      appendPreviewPage={dependency.previewCommentUsecase.appendPreviewPage}
      currentUser={state.authentication.signedInUser}
      organizationId={state.lastAccessedOrganization.item?.id}
      pagePathParam={Number(page)}
      changePathParam={(pageIndex: number) => {
        if (page) {
          history.push(pageIndex.toString());
        } else {
          history.push(id + '/' + pageIndex.toString());
        }
      }}
      onMount={() => {
        dependency.previewCommentUsecase.getCurrentPreviewPage(id!);
      }}
      className={className}
    />
  );
};

export default PreviewCommentEditPage;
